







import { VueConstructor } from 'vue';
import { EditorContent } from '@tiptap/vue-2';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	components: {
		EditorContent: EditorContent as VueConstructor,
	},
	props: {
		editor: {
			type: Object,
			required: true,
		},
	},
});
